type EndLearningSessionHandler = (reason: 'logout' | 'unload') => Promise<void>;

let endHandler: EndLearningSessionHandler | null = null;

export function registerLearningSessionEndHandler(handler: EndLearningSessionHandler): () => void {
  endHandler = handler;
  return () => {
    if (endHandler === handler) {
      endHandler = null;
    }
  };
}

export async function endLearningSession(reason: 'logout' | 'unload' = 'logout'): Promise<void> {
  await endHandler?.(reason);
}
